import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import { AgentWiseSecondReportApi, AgentWiseUniqueCustomerReportApi, DownloadAgentWiseSecondReportApi, DownloadAgentWiseUniqueCustomerReportApi, UserListApi } from "../../Api";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate as FormateDateString } from "../../../helper";
import { BsFiletypeDoc, BsFiletypeDocx, BsFiletypePdf, BsFiletypeXls, BsFiletypeXlsx } from "react-icons/bs";
import { FaFile } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { isJSONString } from "../Chatbox/ChatBox";
import { saveAs } from "file-saver";
import { IoIosArrowBack, IoIosArrowForward, IoMdArrowRoundBack } from "react-icons/io";

function formatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

interface ReportDataType {
    sms_campaign_id: number,
    isBlockedNumber: number,
    campaign_name: string,
    createdAt: string,
    direction: string,
    error_code: number,
    error_message: string,
    from: string,
    id: number,
    media_url: string,
    message: string,
    message_type: string,
    retry_sms_id: number | null,
    sms_gateway_name: string,
    status: number,
    to: string,
    user: {
        name: string,
        email: string,
        role: number
    } | null
}

type FilterTypesType = "Day" | "Week" | "Month"
interface FilterDataType {
    user_id: null | number;
    message_type: string,
    from: string,
    to: string,
    direction: string,
    status: number | null,
    sms_gateway_name: string,
    retry_sms_id: number | null,
    error_code: string,
    from_date: string,
    to_date: string,
}

export default function MonitorAgentWiseDayMonthReport() {
    const [Data, setData] = useState<ReportDataType[]>([]);
    const { state } = useLocation();
    const [FilterType, setFilterType] = useState<FilterTypesType>("Day");
    const [users, setUsers] = useState<{ id: number; name: string }[]>([]);
    const [selectDateName, setSelectDateName] = useState(new Date().toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }));
    const navigate = useNavigate();

    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [Filter, setFilter] = useState<FilterDataType>({
        user_id: null,
        message_type: "",
        from: "",
        to: "",
        direction: "",
        status: null,
        sms_gateway_name: "",
        retry_sms_id: null,
        error_code: "",
        from_date: formatDate(new Date()),
        to_date: formatDate(new Date()),
    });
    const [page, setPage] = useState(1);

    const userList = useQuery({
        queryKey: ["User-List-API"],
        queryFn: UserListApi,
        onSuccess: (resp: AxiosResponse) => {
            setUsers(resp.data?.users || []);
        },
        enabled: false,
    });

    const Report = useQuery({
        queryKey: ["Agent-Wise-Second-Report", state?.id, page, Filter],
        queryFn: AgentWiseSecondReportApi,
        onSuccess: (resp: AxiosResponse) => {
            setData(resp.data?.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: false,
    });

    const ReportDownload = useQuery({
        queryKey: ["Agent-Wise-Second-Report-Download", state?.id, page, Filter],
        queryFn: DownloadAgentWiseSecondReportApi,
        onSuccess: (resp: AxiosResponse) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(resp.data)
            link.download = `Agent_Wise_Detail_Report_${new Date().toISOString()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        enabled: false,
    });

    useEffect(() => {
        if (!state?.id) navigate("/report/agent-wise-day-month/campaign-list");
        Report.refetch();
        userList.refetch();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line
    }, [page]);

    useEffect(() => {
        setPage(1)
        const handler = setTimeout(() => {
            Report.refetch();
        }, 300);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Filter.user_id, Filter.direction, Filter.error_code, Filter.from, Filter.message_type, Filter.retry_sms_id, Filter.sms_gateway_name, Filter.status, Filter.to]);



    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDateName]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    const handleClearSearchFilter = () => {
        setFilter({
            ...Filter,
            user_id: null,
            message_type: "",
            direction: "",
            status: null,
            sms_gateway_name: "",
            retry_sms_id: null,
            error_code: "",
            from_date: "",
            to_date: "",
        });
        Report.refetch();
    };

    const downloadMedia = async (imgUrl: string) => {
        fetch(imgUrl)
            .then((response) => response.blob())
            .then((blob) => {
                saveAs(blob, imgUrl.split("/").pop());
            })
            .catch(() => { });
    };

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="card mt-4">
                    <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                        <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
                            <h2 className="mb-0 fs-3 d-block d-md-inline">Agent Wise (D-W-M) Report</h2>
                            <div className="d-flex gap-3 flex-wrap flex-grow-1 flex-md-grow-0">
                                <button
                                    onClick={() => navigate(-1)}
                                    className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                >
                                    <IoMdArrowRoundBack /> Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex px-3 justify-content-between flex-wrap">
                        <div className="d-flex gap-3">
                            <span
                                style={{ border: "1px solid", minWidth: 70 }}
                                className={`mb-0 text-center fs-14 fw-medium p-2 rounded-3 ${"Day" === FilterType ? "bg-primary" : "border-primary cursor-pointer text-primary"}`}
                                onClick={() => {
                                    if (FilterType === "Day") return;
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(new Date()),
                                        to_date: formatDate(new Date()),
                                    });
                                    setSelectDateName(new Date().toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }))
                                    setFilterType("Day");
                                    setPage(1);
                                }}
                            >Day</span>
                            <span
                                style={{ border: "1px solid", minWidth: 70 }}
                                className={`mb-0 text-center fs-14 fw-medium p-2 rounded-3 ${"Week" === FilterType ? "bg-primary" : "border-primary cursor-pointer text-primary"}`}
                                onClick={() => {
                                    const today = new Date();
                                    const dayOfWeek = today.getDay();
                                    const startDate = new Date(today);
                                    startDate.setDate(today.getDate() - dayOfWeek);
                                    const endDate = new Date(startDate);
                                    endDate.setDate(startDate.getDate() + 6);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(startDate),
                                        to_date: formatDate(endDate),
                                    });
                                    setSelectDateName(startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }) + " To " + endDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }))
                                    setFilterType("Week");
                                    setPage(1);
                                }}
                            >Week</span>
                            <span
                                style={{ border: "1px solid", minWidth: 70 }}
                                className={`mb-0 text-center fs-14 fw-medium p-2 rounded-3 ${"Month" === FilterType ? "bg-primary" : "border-primary cursor-pointer text-primary"}`}
                                onClick={() => {
                                    const today = new Date();
                                    const year = today.getFullYear();
                                    const month = today.getMonth();
                                    const startDate = new Date(year, month, 1);
                                    const endDate = new Date(year, month + 1, 0);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(startDate),
                                        to_date: formatDate(endDate),
                                    });
                                    setSelectDateName(startDate.toLocaleDateString("en-US", { month: "long", year: "numeric" }));
                                    setFilterType("Month");
                                    setPage(1);
                                }}
                            >Month</span>
                        </div>
                        <div className="d-flex gap-3">
                            <button className="btn btn-outline-primary fs-14" onClick={() => {
                                setPage(1);
                                if (FilterType === "Day") {
                                    const date = new Date(Filter.from_date);
                                    date.setDate(date.getDate() - 1);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(date),
                                        to_date: formatDate(date),
                                    });
                                    setSelectDateName(date.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }))
                                } else if (FilterType === "Week") {
                                    const date = new Date(Filter.from_date);
                                    date.setDate(date.getDate() - 1);
                                    const today = new Date(date);
                                    const dayOfWeek = today.getDay();
                                    const startDate = new Date(today);
                                    startDate.setDate(today.getDate() - dayOfWeek);
                                    const endDate = new Date(startDate);
                                    endDate.setDate(startDate.getDate() + 6);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(startDate),
                                        to_date: formatDate(endDate),
                                    });
                                    setSelectDateName(startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }) + " To " + endDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }))
                                } else if (FilterType === "Month") {
                                    const today = new Date(Filter.from_date);
                                    const year = today.getFullYear();
                                    const month = today.getMonth() - 1;
                                    let prevYear = year;
                                    let prevMonth = month;
                                    if (month < 0) {
                                        prevYear--;
                                        prevMonth = 11;
                                    }
                                    const startDate = new Date(prevYear, prevMonth, 1);
                                    const endDate = new Date(prevYear, prevMonth + 1, 0);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(startDate),
                                        to_date: formatDate(endDate),
                                    });
                                    setSelectDateName(startDate.toLocaleDateString("en-US", { month: "long", year: "numeric" }));
                                }
                            }}>
                                <IoIosArrowBack />
                            </button>
                            <p style={{ border: "1px solid", minWidth: 150 }} className="text-center mb-0 fs-14 fw-medium bg-primary p-2 rounded-3">{selectDateName}</p>
                            <button className="btn btn-outline-primary fs-14" onClick={() => {
                                setPage(1);
                                if (FilterType === "Day") {
                                    const date = new Date(Filter.to_date);
                                    date.setDate(date.getDate() + 1);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(date),
                                        to_date: formatDate(date),
                                    });
                                    setSelectDateName(date.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }))
                                } else if (FilterType === "Week") {
                                    const date = new Date(Filter.to_date);
                                    date.setDate(date.getDate() + 1);
                                    const today = new Date(date);
                                    const dayOfWeek = today.getDay();
                                    const startDate = new Date(today);
                                    startDate.setDate(today.getDate() - dayOfWeek);
                                    const endDate = new Date(startDate);
                                    endDate.setDate(startDate.getDate() + 6);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(startDate),
                                        to_date: formatDate(endDate),
                                    });
                                    setSelectDateName(startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }) + " To " + endDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }))
                                } else if (FilterType === "Month") {
                                    const today = new Date(Filter.to_date);
                                    const year = today.getFullYear();
                                    const month = today.getMonth() + 1;
                                    let prevYear = year;
                                    let prevMonth = month;
                                    if (month < 0) {
                                        prevYear--;
                                        prevMonth = 11;
                                    }
                                    const startDate = new Date(prevYear, prevMonth, 1);
                                    const endDate = new Date(prevYear, prevMonth + 1, 0);
                                    setFilter({
                                        ...Filter,
                                        from_date: formatDate(startDate),
                                        to_date: formatDate(endDate),
                                    });
                                    setSelectDateName(startDate.toLocaleDateString("en-US", { month: "long", year: "numeric" }));
                                }
                            }}>
                                <IoIosArrowForward />
                            </button>
                        </div>
                    </div>
                    <div className="card-body border-start-0 border-end-0 p-0">
                        <hr />
                        <AgentWiseReport Filter={Filter} setFilter={setFilter} selectDateName={selectDateName} />
                        <hr />
                        <div className="d-flex align-items-center gap-3 p-3">
                            <h6 className="fw-bold flex-grow-1">Detail Report</h6>
                            <button
                                onClick={handleClearSearchFilter}
                                className="btn btn-secondary d-flex align-items-center justify-content-center gap-2"
                                style={{ minWidth: 130 }}
                            >
                                <MdClear className="fs-5" />
                                Clear Filter
                            </button>
                            <button
                                onClick={() => ReportDownload.refetch()}
                                style={{ minWidth: 130 }}
                                className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                                disabled={ReportDownload.isFetching}
                            >
                                <BiExport className="fs-5" />
                                {ReportDownload.isFetching ? "Exporting.." : "Export"}

                            </button>
                        </div>
                        <div className="table-responsive" style={{ minHeight: 500 }}>
                            <table className="table table-hover table-bordered text-nowrap" id="Detail_Report">
                                <thead>
                                    <tr>
                                        <th style={{ width: 200, minWidth: 200 }}>SR No</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Message Type</th>
                                        <th style={{ width: 200, minWidth: 200 }}>From Number</th>
                                        <th style={{ width: 200, minWidth: 200 }}>To Number</th>
                                        <th style={{ minWidth: 350 }}>User</th>
                                        <th style={{ width: 200, minWidth: 200 }}>User Role</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Direction</th>
                                        <th style={{ width: 350, minWidth: 350 }}>Media</th>
                                        <th style={{ width: 350, minWidth: 350 }}>Message</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Status</th>
                                        <th style={{ width: 250 }}>Sms Gateway Name</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Error Code</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Error Message</th>
                                        <th style={{ width: 200, minWidth: 200 }}>CreatedAt</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>
                                            <select
                                                style={{ width: 240 }}
                                                value={Filter.message_type || ""}
                                                className="form-control w-100"
                                                onChange={(e) => setFilter({ ...Filter, message_type: e.target.value })}
                                            >
                                                <option value="">All</option>
                                                <option value="Individual">Individual</option>
                                                <option value="Broadcast">Broadcast</option>
                                            </select>
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.from}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, from: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.to}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, to: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <select
                                                style={{ width: 240 }}
                                                value={Filter.user_id || ""}
                                                className="form-control w-100"
                                                onChange={(e) => {
                                                    if (e.target.value === "All")
                                                        return setFilter({ ...Filter, user_id: null });
                                                    setFilter({
                                                        ...Filter,
                                                        user_id: Number(e.target.value),
                                                    });
                                                }}
                                            >
                                                <option value="All">All</option>
                                                {users?.map((item, i) => (
                                                    <option key={i} value={item?.id?.toString()}>
                                                        {item?.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </th>
                                        <th>
                                        </th>
                                        <th>
                                            <select
                                                style={{ width: 240 }}
                                                value={Filter.direction || ""}
                                                className="form-control w-100"
                                                onChange={(e) => setFilter({ ...Filter, direction: e.target.value })}
                                            >
                                                <option value="All">All</option>
                                                <option value="Inbound">Inbound</option>
                                                <option value="Outbound">Outbound</option>
                                            </select>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th>
                                            <select
                                                style={{ width: 240 }}
                                                value={Filter.status!}
                                                className="form-control w-100"
                                                onChange={(e) => setFilter({ ...Filter, status: e.target.value ? Number(e.target.value) : null })}
                                            >
                                                <option value="">All</option>
                                                <option value="0">Pending</option>
                                                <option value="1">Sent</option>
                                                <option value="2">Delivered</option>
                                                <option value="3">Undelivered</option>
                                                <option value="4">Failed</option>
                                                <option value="5">Delivery Unknown</option>
                                                <option value="6">Delivery Unconfirmed</option>
                                                <option value="7">Unknown Gateway</option>
                                            </select>
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.sms_gateway_name}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, sms_gateway_name: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.error_code}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, error_code: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Data && Data[0] ? (
                                        Data.map((item, i) => (
                                            <tr>
                                                <td>{i + 1 + (page - 1) * 10}</td>
                                                <td>{item?.message_type || " - "}</td>
                                                <td>{item?.from || " - "}</td>
                                                <td className={item?.direction === "Outbound" ? "cursor-pointer" : ""} onClick={() => {
                                                    if (item?.direction === "Outbound") navigate('/chat-box', { state: { id: item?.sms_campaign_id, name: item?.campaign_name, Customer_Number: item?.to, isBlockedNumber: item?.isBlockedNumber ? true : false } })
                                                }}>{item?.to || " - "}</td>
                                                <td>
                                                    <p className="mb-0">{item?.user?.name}</p>
                                                    <p className="mb-0">
                                                        <small>{item?.user?.email}</small>
                                                    </p>
                                                </td>
                                                <td>{item?.user?.role === 1 ? "Agent" : item?.user?.role === 2 ? "Monitor" : " - "}</td>

                                                <td>{item?.direction || " - "}</td>
                                                <td className="text-center">
                                                    <div
                                                        className={`d-flex justify-content-center px-3 gap-2 flex-wrap`}
                                                    >
                                                        {(!item?.media_url || JSON.parse(item?.media_url).length === 0) ? (
                                                            <p className="mb-0">-</p>
                                                        ) : (
                                                            isJSONString(item?.media_url) &&
                                                            JSON.parse(item?.media_url).map(
                                                                (
                                                                    item: { media_url: string; content_type: string },
                                                                    i: number
                                                                ) => {
                                                                    if (item?.content_type?.startsWith("image/"))
                                                                        return (
                                                                            <div
                                                                                className="showImages bg-dark d-block"
                                                                                key={i}
                                                                                style={{ height: 75, width: 75 }}
                                                                            >
                                                                                <FiDownload
                                                                                    color="black"
                                                                                    className="my-1 removeImageBtn p-1"
                                                                                    style={{ height: 25, width: 25 }}
                                                                                    onClick={() =>
                                                                                        downloadMedia(item?.media_url)
                                                                                    }
                                                                                />
                                                                                <img
                                                                                    style={{ width: "100%", height: "100%" }}
                                                                                    src={item?.media_url}
                                                                                    alt="img"
                                                                                    className="shadow-none object-fit-contain"
                                                                                />
                                                                            </div>
                                                                        );
                                                                    else
                                                                        return (
                                                                            <div
                                                                                className={`showImages bg-dark overflow-hidden`}
                                                                                style={{ height: 75, width: 75 }}
                                                                                key={i}
                                                                            >
                                                                                <FiDownload

                                                                                    color="black"
                                                                                    className="my-1 removeImageBtn"
                                                                                    onClick={() =>
                                                                                        downloadMedia(item?.media_url)
                                                                                    }
                                                                                />
                                                                                <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                                                                    <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                                                                        {item?.content_type ===
                                                                                            "application/vnd.ms-excel" ? (
                                                                                            <BsFiletypeXls
                                                                                                className="w-100 text-success"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                                                                            <BsFiletypeXlsx
                                                                                                className="w-100 text-success"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/msword" ? (
                                                                                            <BsFiletypeDoc
                                                                                                className="w-100 text-primary"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                                                                            <BsFiletypeDocx
                                                                                                className="w-100 text-primary"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/pdf" ? (
                                                                                            <BsFiletypePdf
                                                                                                className="w-100 text-danger"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : (
                                                                                            <FaFile
                                                                                                className="w-100"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                    <p
                                                                                        className="mb-2 fs-11 text-center"
                                                                                        style={{ fontSize: 11 }}
                                                                                    >
                                                                                        {/* {item?.name} */}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                }
                                                            )
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ maxWidth: 500, textWrap: "balance", overflow: "hidden" }}>{item?.message || " - "}</td>
                                                <td className={`text-center ${item?.status === 0 ? 'text-warning fw-bold' :
                                                    item?.status === 1 ? 'text-success fw-bold' :
                                                        item?.status === 2 ? 'text-success fw-bold' :
                                                            item?.status === 3 ? 'text-danger fw-bold' :
                                                                item?.status === 4 ? 'text-danger fw-bold' :
                                                                    item?.status === 5 ? 'text-info fw-bold' :
                                                                        item?.status === 6 ? 'text-info fw-bold' :
                                                                            item?.status === 7 ? 'text-secondary fw-bold' :
                                                                                'text-muted'
                                                    }`}>
                                                    {item.status === 0 ? "Pending" :
                                                        item.status === 1 ? "Sent" :
                                                            item.status === 2 ? "Delivered" :
                                                                item.status === 3 ? "Undelivered" :
                                                                    item.status === 4 ? "Failed" :
                                                                        item.status === 5 ? "Delivery Unknown" :
                                                                            item.status === 6 ? "Delivery Unconfirmed" :
                                                                                item.status === 7 ? "Unknown Gateway" : " - "}
                                                </td>

                                                <td>{item?.sms_gateway_name || " - "}</td>
                                                <td>{item?.error_code || " - "}</td>
                                                <td>{item?.error_message || " - "}</td>
                                                <td>{FormateDateString(item?.createdAt) || " - "}</td>
                                            </tr>
                                        ))
                                    ) : !Report.isFetching ? (
                                        <tr>
                                            <td colSpan={14} height={50}>
                                                <div className="text-center">
                                                    <p className="mb-0 fs-5 fw-semibold">
                                                        No data found
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            {Report.isFetching ? (
                                <center className="mb-3">
                                    <i
                                        className=" my-2 fa loader"
                                        style={{ fontSize: "30px", color: "black" }}
                                    ></i>
                                </center>
                            ) : null}
                        </div>
                        {info && info.total_page ? (
                            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                <RenderPaginationButtons
                                    info={info}
                                    currentPage={page}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
};

interface AgnetReportDataType {
    campaign_name: string,
    Unique_Customer: string,
    Message_Count: string,
    Undelivered: string,
    Delivered: string,
    user: {
        name: string,
        email: string,
        role: number,
        id: number
    }
}

function AgentWiseReport({ Filter, selectDateName, setFilter }: { Filter: FilterDataType, selectDateName: string, setFilter: (v: FilterDataType) => void }) {
    const [Data, setData] = useState<AgnetReportDataType[]>([]);
    const { state } = useLocation();
    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [page, setPage] = useState(2);

    const Report = useQuery({
        queryKey: ["Agent-Wise-Unique-Customer-Report", state?.id, page, Filter],
        queryFn: AgentWiseUniqueCustomerReportApi,
        onSuccess: (resp: AxiosResponse) => {
            setData(resp.data?.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: false,
    });

    const ReportDownload = useQuery({
        queryKey: ["Agent-Wise-Unique-Customer-Report-Download", state?.id, page, Filter],
        queryFn: DownloadAgentWiseUniqueCustomerReportApi,
        onSuccess: (resp: AxiosResponse) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(resp.data)
            link.download = `Agent_Wise_Summary_Report_${new Date().toISOString()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        enabled: false,
    });

    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line
    }, [page]);

    useEffect(() => {
        setPage(1);
        Report.refetch();
        // eslint-disable-next-line
    }, [selectDateName]);
    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    return (
        <React.Fragment>
            <div className="d-flex align-items-center gap-3 p-3">
                <h6 className="fw-bold flex-grow-1">Summary Report</h6>
                <button
                    onClick={() => ReportDownload.refetch()}
                    style={{ minWidth: 130 }}
                    className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                    disabled={ReportDownload.isFetching}
                >
                    <BiExport className="fs-5" />
                    {ReportDownload.isFetching ? "Exporting.." : "Export"}

                </button>
            </div>
            <div className="table-responsive">
                <table className="table table-hover table-bordered text-nowrap">
                    <thead>
                        <tr>
                            <th style={{ width: 200 }}>SR No</th>
                            <th>User</th>
                            <th>Unique Customer</th>
                            <th>Message Count</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Data && Data[0] ? (
                            Data.map((item, i) => (
                                <tr className="cursor-pointer" onClick={() => {
                                    setFilter({ ...Filter, user_id: item?.user?.id });
                                    document.getElementById('Detail_Report')?.scrollIntoView();
                                }}>
                                    <td>{i + 1 + (page - 1) * 10}</td>
                                    <td>
                                        <p className="mb-0">{item?.user?.name}</p>
                                        <p className="mb-0">
                                            <small>{item?.user?.email}</small>
                                        </p>
                                    </td>
                                    <td>{item?.Unique_Customer || " - "}</td>
                                    <td>{item?.Message_Count || " - "}</td>
                                </tr>
                            ))
                        ) : !Report.isFetching ? (
                            <tr>
                                <td colSpan={5} height={50}>
                                    <div className="text-center">
                                        <p className="mb-0 fs-5 fw-semibold">
                                            No data found
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
                {Report.isFetching ? (
                    <center className="mb-3">
                        <i
                            className=" my-2 fa loader"
                            style={{ fontSize: "30px", color: "black" }}
                        ></i>
                    </center>
                ) : null}
            </div>
            {info && info.total_page ? (
                <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                    <RenderPaginationButtons
                        info={info}
                        currentPage={page}
                        handlePageChange={handlePageChange}
                    />
                </div>
            ) : null}
        </React.Fragment>
    );
}

